export { InfoCard } from './InfoCard';

